export enum CallReplayMethod {
  None = 'none',
  Roadshow = 'roadshow',
}
